module.exports = __webpack_public_path__ + "static/media/dashboardtabsimg.d7210fd7.png";